export default __webpack_public_path__ + "static/media/chain-17.72213a90.png";